export default "__VITE_ASSET__66bb9a96__$_?nuxt_component=async&nuxt_component_name=SvgoCluth__"